import action from "../commons/patientActionStatus";

export const getPatientDetailsRequestAction = (patientId, isSilent = false) => {
  return {
    type: action.GET_PATIENT_DETAILS_REQUEST,
    status: "GET_PATIENT_DETAILS_REQUEST",
    requestState: true,
    payload: {
      patientId,
      isSilent
    },
  };
};

export const getPatientDetailsSuccessAction = (result) => {
  return {
    type: action.GET_PATIENT_DETAILS_SUCCESS,
    status: "Patient details retrieved sucessfully",
    result,
    requestState: false,
  };
};

export const getPatientDetailsFailureAction = (error) => {
  return {
    type: action.GET_PATIENT_DETAILS_FAILURE,
    status: "Get Patient details failure",
    error,
    requestState: false,
  };
};

export const getPatientVitalsRequestAction = (patientId) => {
  return {
    type: action.GET_PATIENT_VITALS_REQUEST,
    status: "GET_PATIENT_VITALS_REQUEST",
    requestState: true,
    payload: {
      patientId,
    },
  };
};

export const getPatientVitalsSuccessAction = (result) => {
  return {
    type: action.GET_PATIENT_VITALS_SUCCESS,
    status: "Patient vitals retrieved sucessfully",
    result,
    requestState: false,
  };
};

export const getPatientVitalsFailureAction = (error) => {
  return {
    type: action.GET_PATIENT_VITALS_FAILURE,
    status: "Get Patient vitals failure",
    error,
    requestState: false,
  };
};

export const getPatientConsultationDetailsRequestAction = (consultationId, ) => {
  return {
    type: action.GET_PATIENT_CONSULTATION_REQUEST,
    status: "GET_PATIENT_CONSULTATION_REQUEST",
    requestState: true,
    payload: {
      consultationId
    },
  };
};

export const getPatientConsultationDetailsSuccessAction = (result) => {
  return {
    type: action.GET_PATIENT_CONSULTATION_SUCCESS,
    status: "Patient consultations retrieved sucessfully",
    result,
    requestState: false,
  };
};

export const getPatientConsultationDetailsFailureAction = (error) => {
  return {
    type: action.GET_PATIENT_CONSULTATION_FAILURE,
    status: "Get Patient consultations failure",
    error,
    requestState: false,
  };
};

export const getPatientVitalsRangeRequestAction = (patientId) => {
  return {
    type: action.GET_PATIENT_VITALS_RANGE_REQUEST,
    status: "GET_PATIENT_VITALS_RANGE_REQUEST",
    requestState: true,
    payload: {
      patientId,
    },
  };
};

export const getPatientVitalsRangeSuccessAction = (result) => {
  return {
    type: action.GET_PATIENT_VITALS_RANGE_SUCCESS,
    status: "Patient vitals range retrieved sucessfully",
    result,
    requestState: false,
  };
};

export const getPatientVitalsRangeFailureAction = (error) => {
  return {
    type: action.GET_PATIENT_VITALS_RANGE_FAILURE,
    status: "Get Patient vitals range failure",
    error,
    requestState: false,
  };
};

export const getPatientLeapScoreRequestAction = (patientId) => {
  return {
    type: action.GET_PATIENT_LEAP_SCORE_REQUEST,
    status: "GET_PATIENT_LEAP_SCORE_REQUEST",
    requestState: true,
    payload: {
      patientId,
    },
  };
};

export const getPatientLeapScoreSuccessAction = (result) => {
  return {
    type: action.GET_PATIENT_LEAP_SCORE_SUCCESS,
    status: "Patient Leap Score retrieved sucessfully",
    result,
    requestState: false,
  };
};

export const getPatientLeapScoreFailureAction = (error) => {
  return {
    type: action.GET_PATIENT_LEAP_SCORE_FAILURE,
    status: "Get Patient leap score failure",
    error,
    requestState: false,
  };
};

export const getPatientHistoryDataRequestAction = (patientId) => {
  return {
    type: action.GET_PATIENT_HISTORY_REQUEST,
    status: "GET_PATIENT_HISTORY_REQUEST",
    requestState: true,
    payload: {
      patientId,
    },
  };
};

export const getPatientHistoryDataSuccessAction = (result) => {
  return {
    type: action.GET_PATIENT_HISTORY_SUCCESS,
    status: "Patient history details retrieved sucessfully",
    result,
    requestState: false,
  };
};

export const getPatientHistoryDataFailureAction = (error) => {
  return {
    type: action.GET_PATIENT_HISTORY_FAILURE,
    status: "Get Patient history failure",
    error,
    requestState: false,
  };
};

export const createPatientHistoryDataRequestAction = (patientId, body) => {
  return {
    type: action.CREATE_PATIENT_HISTORY_REQUEST,
    status: "CREATE_PATIENT_HISTORY_REQUEST",
    requestState: true,
    payload: {
      patientId,
      body,
    },
  };
};

export const createPatientHistoryDataSuccessAction = (result) => {
  return {
    type: action.CREATE_PATIENT_HISTORY_SUCCESS,
    status: "Patient history details created sucessfully",
    result,
    requestState: false,
  };
};

export const createPatientHistoryDataFailureAction = (error) => {
  return {
    type: action.CREATE_PATIENT_HISTORY_FAILURE,
    status: "create Patient history failure",
    error,
    requestState: false,
  };
};

export const updatePatientHistoryDataRequestAction = (patientId, body) => {
  return {
    type: action.UPDATE_PATIENT_HISTORY_REQUEST,
    status: "UPDATE_PATIENT_HISTORY_REQUEST",
    requestState: true,
    payload: {
      patientId,
      body,
    },
  };
};

export const updatePatientHistoryDataSuccessAction = (result) => {
  return {
    type: action.UPDATE_PATIENT_HISTORY_SUCCESS,
    status: "Patient history details updated sucessfully",
    result,
    requestState: false,
  };
};

export const updatePatientHistoryDataFailureAction = (error) => {
  return {
    type: action.UPDATE_PATIENT_HISTORY_FAILURE,
    status: "update Patient history failure",
    error,
    requestState: false,
  };
};

export const createVitalsRequestAction = (consultationId, body) => {
  return {
    type: action.CREATE_VITALS_REQUEST,
    status: "CREATE_VITALS_REQUEST",
    requestState: true,
    payload: {
      consultationId,
      body,
    },
  };
};

export const createVitalsSuccessAction = (result) => {
  return {
    type: action.CREATE_VITALS_SUCCESS,
    status: "Vitals created sucessfully",
    result,
    requestState: false,
  };
};

export const createVitalsFailureAction = (error) => {
  return {
    type: action.CREATE_VITALS_FAILURE,
    status: "creates vitals failure",
    error,
    requestState: false,
  };
};

export const getPatientTestsRequestAction = (patientId) => {
  return {
    type: action.GET_PATIENT_TESTS_REQUEST,
    status: "GET_PATIENT_TESTS_REQUEST",
    requestState: true,
    payload: {
      patientId,
    },
  };
};

export const getPatientTestsSuccessAction = (result) => {
  return {
    type: action.GET_PATIENT_TESTS_SUCCESS,
    status: "Patient Tests retrieved sucessfully",
    result,
    requestState: false,
  };
};

export const getPatientTestsFailureAction = (error) => {
  return {
    type: action.GET_PATIENT_TESTS_FAILURE,
    status: "patient tests get failure",
    error,
    requestState: false,
  };
};

export const resetVitalsCreationState = () => {
  return {
    type: action.RESET_VITALS_CREATION_STATE,
  };
};

export const submitPatientTestsRequestAction = (testId, body) => {
  return {
    type: action.SUBMIT_PATIENT_TESTS_REQUEST,
    status: "SUBMIT_PATIENT_TESTS_REQUEST",
    requestState: true,
    payload: {
      testId,
      body,
    },
  };
};

export const submitPatientTestsSuccessAction = (result) => {
  return {
    type: action.SUBMIT_PATIENT_TESTS_SUCCESS,
    status: "Patient Tests submitted sucessfully",
    result,
    requestState: false,
  };
};

export const submitPatientTestsFailureAction = (error) => {
  return {
    type: action.SUBMIT_PATIENT_TESTS_FAILURE,
    status: "patient tests submit failure",
    error,
    requestState: false,
  };
};

export const resetTestCreationState = () => {
  return {
    type: action.RESET_TEST_CREATION_STATE,
  };
};

export const getLifestyleChartsRequestAction = (patientId) => {
  return {
    type: action.GET_LIFESTYLE_CHARTS_REQUEST,
    status: "GET_LIFESTYLE_CHARTS_REQUEST",
    requestState: true,
    payload: {
      patientId,
    },
  };
};

export const getLifestyleChartsSuccessAction = (result) => {
  return {
    type: action.GET_LIFESTYLE_CHARTS_SUCCESS,
    status: "Lifestyle charts retrieved successfully",
    result,
    requestState: false,
  };
};

export const getLifestyleChartsFailureAction = (error) => {
  return {
    type: action.GET_LIFESTYLE_CHARTS_FAILURE,
    status: "Failed to retrieve lifestyle charts",
    error,
    requestState: false,
  };
};

export const getRecommendedDietPlanRequestAction = (consultationId) => {
  return {
    type: action.GET_RECOMMENDED_DIET_PLAN_REQUEST,
    status: "GET_RECOMMENDED_DIET_PLAN_REQUEST",
    requestState: true,
    payload: {
      consultationId,
    },
  };
};

export const getRecommendedDietPlanSuccessAction = (result) => {
  return {
    type: action.GET_RECOMMENDED_DIET_PLAN_SUCCESS,
    status: "Diet plan retrieved successfully",
    result,
    requestState: false,
  };
};

export const getRecommendedDietPlanFailureAction = (error) => {
  return {
    type: action.GET_RECOMMENDED_DIET_PLAN_FAILURE,
    status: "Failed to retrieve diet plan",
    error,
    requestState: false,
  };
};

export const getRecommendedLifestyleRequestAction = (consultationId) => {
  return {
    type: action.GET_RECOMMENDED_LIFESTYLE_REQUEST,
    status: "GET_RECOMMENDED_LIFESTYLE_REQUEST",
    requestState: true,
    payload: {
      consultationId,
    },
  };
};

export const getRecommendedLifestyleSuccessAction = (result) => {
  return {
    type: action.GET_RECOMMENDED_LIFESTYLE_SUCCESS,
    status: "Recommended lifestyle retrieved successfully",
    result,
    requestState: false,
  };
};

export const getRecommendedLifestyleFailureAction = (error) => {
  return {
    type: action.GET_RECOMMENDED_LIFESTYLE_FAILURE,
    status: "Failed to retrieve recommended lifestyle",
    error,
    requestState: false,
  };
};


export const createOrUpdateRecommendedLifestyleRequestAction = (consultationId, body) => {
  return {
    type: action.CREATE_OR_UPDATE_RECOMMENDED_LIFESTYLE_REQUEST,
    status: "CREATE_OR_UPDATE_RECOMMENDED_LIFESTYLE_REQUEST",
    requestState: true,
    payload: {
      consultationId,
      body,
    },
  };
};

export const createOrUpdateRecommendedLifestyleSuccessAction = (result) => {
  return {
    type: action.CREATE_OR_UPDATE_RECOMMENDED_LIFESTYLE_SUCCESS,
    status: "Recommended lifestyle updated successfully",
    result,
    requestState: false,
  };
};

export const createOrUpdateRecommendedLifestyleFailureAction = (error) => {
  return {
    type: action.CREATE_OR_UPDATE_RECOMMENDED_LIFESTYLE_FAILURE,
    status: "Failed to update recommended lifestyle",
    error,
    requestState: false,
  };
};

export const getEmotionChartsRequestAction = (patientId) => {
  return {
    type: action.GET_EMOTION_CHARTS_REQUEST,
    status: "GET_EMOTION_CHARTS_REQUEST",
    requestState: true,
    payload: {
      patientId,
    },
  };
};

export const getEmotionChartsSuccessAction = (result) => {
  return {
    type: action.GET_EMOTION_CHARTS_SUCCESS,
    status: "Emotion charts retrieved successfully",
    result,
    requestState: false,
  };
};

export const getEmotionChartsFailureAction = (error) => {
  return {
    type: action.GET_VISITS_CHARTS_FAILURE,
    status: "Failed to retrieve Emotion charts",
    error,
    requestState: false,
  };
};

export const getPhysicalFitnessRequestAction = (patientId) => {
  return {
    type: action.GET_PHYSICAL_FITNESS_REQUEST,
    status: "GET_PHYSICAL_FITNESS_REQUEST",
    requestState: true,
    payload: {
      patientId,
    },
  };
};

export const getPhysicalFitnessSuccessAction = (result) => {
  return {
    type: action.GET_PHYSICAL_FITNESS_SUCCESS,
    status: "Physical fitness data retrieved successfully",
    result,
    requestState: false,
  };
};

export const getPhysicalFitnessFailureAction = (error) => {
  return {
    type: action.GET_PHYSICAL_FITNESS_FAILURE,
    status: "Failed to retrieve physical fitness data",
    error,
    requestState: false,
  };
};

export const getVisitsChartsRequestAction = (patientId) => {
  return {
    type: action.GET_VISITS_CHARTS_REQUEST,
    status: "GET_VISITS_CHARTS_REQUEST",
    requestState: true,
    payload: {
      patientId,
    },
  };
};

export const getVisitsChartsSuccessAction = (result) => {
  return {
    type: action.GET_VISITS_CHARTS_SUCCESS,
    status: "Visits charts retrieved successfully",
    result,
    requestState: false,
  };
};

export const getVisitsChartsFailureAction = (error) => {
  return {
    type: action.GET_VISITS_CHARTS_FAILURE,
    status: "Failed to retrieve Visits charts",
    error,
    requestState: false,
  };
};

export const getWeightGainChartRequestAction = (patientId) => {
  return {
    type: action.GET_WEIGHT_GAIN_CHART_REQUEST,
    status: "GET_WEIGHT_GAIN_CHART_REQUEST",
    requestState: true,
    payload: {
      patientId,
    },
  };
};

export const getWeightGainChartSuccessAction = (result) => {
  return {
    type: action.GET_WEIGHT_GAIN_CHART_SUCCESS,
    status: "WeightGain chart retrieved successfully",
    result,
    requestState: false,
  };
};

export const getWeightGainChartFailureAction = (error) => {
  return {
    type: action.GET_WEIGHT_GAIN_CHART_FAILURE,
    status: "Failed to retrieve WeightGain chart",
    error,
    requestState: false,
  };
};

export const getPatientComplaintsRequestAction = (patientId, status) => {
  return {
    type: action.GET_PATIENT_COMPLAINTS_REQUEST,
    status: "GET_PATIENT_COMPLAINTS_REQUEST",
    requestState: true,
    payload: {
      patientId,
      status
    },
  };
};

export const getPatientEndedComplaintsRequestAction = (patientId, status) => {
  return {
    type: action.GET_PATIENT_ENDED_COMPLAINTS_REQUEST,
    status: "GET_PATIENT_COMPLAINTS_REQUEST",
    requestState: true,
    payload: {
      patientId,
      status
    },
  };
};


export const getPatientComplaintsSuccessAction = (result, dataType) => {
  return {
    type: action.GET_PATIENT_COMPLAINTS_SUCCESS,
    status: "Patient Complaints retrieved sucessfully",
    result,
    dataType,
    requestState: false,
  };
};

export const getPatientComplaintsFailureAction = (error) => {
  return {
    type: action.GET_PATIENT_COMPLAINTS_FAILURE,
    status: "Get Patient complaints failure",
    error,
    requestState: false,
  };
};

export const getPatientRisksRequestAction = (patientId, status) => {
  return {
    type: action.GET_PATIENT_RISKS_REQUEST,
    status: "GET_PATIENT_RISKS_REQUEST",
    requestState: true,
    payload: {
      patientId,
      status
    },
  };
};

export const getPatientRisksAssessRequestAction = (patientId) => {
  return {
    type: action.GET_PATIENT_ASSESS_RISKS_REQUEST,
    status: "GET_PATIENT_ASSESS_RISKS_REQUEST",
    requestState: true,
    payload: {
      patientId,
    },
  };
};

export const getPatientEndedRisksRequestAction = (patientId, status) => {
  return {
    type: action.GET_PATIENT_ENDED_RISKS_REQUEST,
    status: "GET_PATIENT_ENDED_RISKS_REQUEST",
    requestState: true,
    payload: {
      patientId,
      status
    },
  };
};

export const getPatientRisksSuccessAction = (result, dataType) => {
  return {
    type: action.GET_PATIENT_RISKS_SUCCESS,
    status: "Patient risks retrieved sucessfully",
    result, 
    dataType,
    requestState: false,
  };
};

export const getPatientRisksFailureAction = (error) => {
  return {
    type: action.GET_PATIENT_RISKS_FAILURE,
    status: "Get Patient risk failure",
    error,
    requestState: false,
  };
};

export const createComplaintRequestAction = (patientId, body) => {
  return {
    type: action.CREATE_COMPLAINT_REQUEST,
    status: "CREATE_COMPLAINT_REQUEST",
    requestState: true,
    payload: {
      patientId,
      body,
    },
  };
};

export const createComplaintSuccessAction = (result) => {
  return {
    type: action.CREATE_COMPLAINT_SUCCESS,
    status: "Complaint created sucessfully",
    result,
    requestState: false,
  };
};

export const createComplaintFailureAction = (error) => {
  return {
    type: action.CREATE_COMPLAINT_FAILURE,
    status: "complaint creation failure",
    error,
    requestState: false,
  };
};

export const createRiskRequestAction = (patientId, body) => {
  return {
    type: action.CREATE_RISK_REQUEST,
    status: "CREATE_RISK_REQUEST",
    requestState: true,
    payload: {
      patientId,
      body,
    },
  };
};

export const createRiskSuccessAction = (result) => {
  return {
    type: action.CREATE_RISK_SUCCESS,
    status: "Risk created sucessfully",
    result,
    requestState: false,
  };
};

export const createRiskFailureAction = (error) => {
  return {
    type: action.CREATE_RISK_FAILURE,
    status: "Risk Creation failure",
    error,
    requestState: false,
  };
};

// -----

export const updateComplaintRequestAction = (patientId, complaintId, body) => {
  return {
    type: action.UPDATE_COMPLAINT_REQUEST,
    status: "UPDATE_COMPLAINT_REQUEST",
    requestState: true,
    payload: {
      patientId,
      complaintId,
      body,
    },
  };
};

export const updateComplaintSuccessAction = (result) => {
  return {
    type: action.UPDATE_COMPLAINT_SUCCESS,
    status: "Complaint updated sucessfully",
    result,
    requestState: false,
  };
};

export const updateComplaintFailureAction = (error) => {
  return {
    type: action.UPDATE_COMPLAINT_FAILURE,
    status: "complaint updation failure",
    error,
    requestState: false,
  };
};

export const updateRiskRequestAction = (patientId,riskId, body) => {
  return {
    type: action.UPDATE_RISK_REQUEST,
    status: "UPDATE_RISK_REQUEST",
    requestState: true,
    payload: {
      patientId,
      riskId,
      body,
    },
  };
};

export const updateRiskSuccessAction = (result) => {
  return {
    type: action.UPDATE_RISK_SUCCESS,
    status: "Risk updated sucessfully",
    result,
    requestState: false,
  };
};

export const updateRiskFailureAction = (error) => {
  return {
    type: action.UPDATE_RISK_FAILURE,
    status: "Risk updationfailure",
    error,
    requestState: false,
  };
};

export const updatePatientDetailsRequestAction = (patientId, body) => {
  return {
    type: action.UPDATE_PATIENT_DETAILS_REQUEST,
    status: "UPDATE_PATIENT_DETAILS_REQUEST",
    requestState: true,
    payload: {
      patientId,
      body
    },
  };
};

export const updatePatientDetailsSuccessAction = (result) => {
  return {
    type: action.UPDATE_PATIENT_DETAILS_SUCCESS,
    status: "Patient details updated sucessfully",
    result,
    requestState: false,
  };
};

export const updatePatientDetailsFailureAction = (error) => {
  return {
    type: action.UPDATE_PATIENT_DETAILS_FAILURE,
    status: "update Patient details failure",
    error,
    requestState: false,
  };
};

export const addWeightGainChartDataRequestAction = (consultationId,body, patientId) => {
  return {
    type: action.ADD_WEIGHT_GAIN_CHART_DATA_REQUEST,
    status: "ADD_WEIGHT_GAIN_CHART_DATA_REQUEST",
    requestState: true,
    payload: {
     consultationId,
     body,
     patientId
    },
  };
};

export const addWeightGainChartDataSuccessAction = (result) => {
  return {
    type: action.ADD_WEIGHT_GAIN_CHART_DATA_SUCCESS,
    status: "WeightGain chart data added successfully",
    result,
    requestState: false,
  };
};

export const addWeightGainChartDataFailureAction = (error) => {
  return {
    type: action.ADD_WEIGHT_GAIN_CHART_DATA_FAILURE,
    status: "Failed to add WeightGain chart data",
    error,
    requestState: false,
  };
};

export const getPrescriptionChartRequestionAction= (patientId) => {
  return {
    type: action.GET_PRESCRIPTION_CHART_REQUEST,
    status: "GET_PRESCRIPTION_CHART_REQUEST",
    requestState: true,
    payload: {
      patientId,
    },
  };
};

export const getPrescriptionChartSuccessAction = (result) => {
  return {
    type: action.GET_PRESCRIPTION_CHART_SUCCESS,
    status: "Prescription chart retrieved successfully",
    result,
    requestState: false,
  };
};

export const getPrescriptionChartFailureAction = (error) => {
  return {
    type: action.GET_PRESCRIPTION_CHART_FAILURE,
    status: "Failed to retrieve prescription chart",
    error,
    requestState: false,
  };
};

export const getDFMRChartRequestAction = (patientId) => {
  return {
    type: action.GET_DFMR_CHART_REQUEST,
    status: "GET_DFMR_CHART_REQUEST",
    requestState: true,
    payload: {
      patientId,
    },
  };
};

export const getDFMRChartSuccessAction = (result) => {
  return {
    type: action.GET_DFMR_CHART_SUCCESS,
    status: "DFMR chart retrieved successfully",
    result,
    requestState: false,
  };
};

export const getDFMRChartFailureAction = (error) => {
  return {
    type: action.GET_DFMR_CHART_FAILURE,
    status: "Failed to retrieve DFMR chart",
    error,
    requestState: false,
  };
};

export const getEmotionDataRequestAction = (patientId) => {
  return {
    type: action.GET_EMOTION_DATA_REQUEST,
    status: "GET_EMOTION_DATA_REQUEST",
    requestState: true,
    payload: {
      patientId,
    },
  };
};

export const getEmotionDataSuccessAction = (result) => {
  return {
    type: action.GET_EMOTION_DATA_SUCCESS,
    status: "Emotion charts retrieved successfully",
    result,
    requestState: false,
  };
};

export const getEmotionDataFailureAction = (error) => {
  return {
    type: action.GET_EMOTION_DATA_FAILURE,
    status: "Failed to retrieve Emotion charts",
    error,
    requestState: false,
  };
};

export const createConditionRequestAction = (consultationId, body) => {
  return {
    type: action.CREATE_CONDITION_REQUEST,
    status: "CREATE_CONDITION_REQUEST",
    requestState: true,
    payload: {
      consultationId,
      body,
    },
  };
};

export const createConditionSuccessAction = (result) => {
  return {
    type: action.CREATE_CONDITION_SUCCESS,
    status: "Condition created sucessfully",
    result,
    requestState: false,
  };
};

export const createConditionFailureAction = (error) => {
  return {
    type: action.CREATE_CONDITION_FAILURE,
    status: "create condition failure",
    error,
    requestState: false,
  };
};

export const getConditionRequestAction = () => {
  return {
    type: action.GET_CONDITION_REQUEST,
    status: "GET_CONDITION_REQUEST",
    requestState: true,
   
  };
};

export const getConditionSuccessAction = (result) => {
  return {
    type: action.GET_CONDITION_SUCCESS,
    status: "Condition GET sucessfully",
    result,
    requestState: false,
  };
};

export const getConditionFailureAction = (error) => {
  return {
    type: action.GET_CONDITION_FAILURE,
    status: "Get condition failure",
    error,
    requestState: false,
  };
};

export const resetConditionCreation = () => {
  return {
    type: action.RESET_CONDITION_CREATION_STATE,
  };
};

export const getConditionTimelineRequestAction = (patientId) => {
  return {
    type: action.GET_CONDITION_TIMELINE_REQUEST,
    status: "GET_CONDITION_TIMELINE_REQUEST",
    requestState: true,
    payload: {
      patientId,
    },
  };
};

export const getConditionTimelineSuccessAction = (result) => {
  return {
    type: action.GET_CONDITION_TIMELINE_SUCCESS,
    status: "Timeline Condition GET sucessfully",
    result,
    requestState: false,
  };
};

export const getConditionTimelineFailureAction = (error) => {
  return {
    type: action.GET_CONDITION_TIMELINE_FAILURE,
    status: "Get timeline condition failure",
    error,
    requestState: false,
  };
};
